// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-GNMh","active":"styles_active__Z2oLk","content":"styles_content__yG8FD"};